<div class="bg-black-1 rounded py-3 px-4">
    <ng-content></ng-content>
</div>